export default function ReportFooter({
  universityInfo,
  collegeInfo,
  currentDate,
}) {
  return (
    <div className="pt-4 mt-8 text-xs text-center border-t border-gray-200 md:mt-12 md:text-sm text-slate-500">
      <p>
        This report is generated by the{" "}
        {universityInfo?.name || universityInfo.name} Learning Management
        System.
      </p>
      <p className="mt-1">For any queries, please contact the department.</p>
      <p className="mt-4 text-xs">
        © {new Date().getFullYear()}{" "}
        {collegeInfo?.name + " and " + universityInfo?.name}. All rights
        reserved.
      </p>
      {/* Report Generated Date - Center  */}
      <div className="text-center">
        <p className="text-xs text-slate-500 md:text-sm">Report Generated</p>
        <p className="text-xs font-medium text-slate-700 md:text-sm">
          {currentDate}
        </p>
      </div>
    </div>
  );
}
